import { createFileRoute } from '@tanstack/react-router';
import { OperationsQuoteReviewPage } from '@/features/operations/quote-review-page';

export const Route = createFileRoute('/operations/quotes/$id/')({
  component: OperationsQuoteReviewRoute,
});

function OperationsQuoteReviewRoute() {
  const { id } = Route.useParams();
  return <OperationsQuoteReviewPage quoteId={id} />;
}
